import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GlobalDataState } from '../../Context';
import './Recomendation.css';
const Recommendation = ({id}) => {
    const [recomm,setRecomm]=useState({});
    const {setClickedId}=GlobalDataState();
    useEffect(()=>{
        getRecommendation();
    },[id])

    async function getRecommendation(){
        const data =await fetch(`https://api.themoviedb.org/3/movie/${id}/recommendations?api_key=95827c3fee6b7922a023ac65e529dca2&language=en-US&page=1h`)
        const json=await data.json();
        setRecomm(json.results)
    }
    // console.log()
    function handlesetId(idx){
        setClickedId(idx);
     }


     let box = document.querySelector('.Ritems');

    const btnpressprev = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft - width;
        console.log(width)
    }

    const btnpressnext = () => {
        let width = box.clientWidth;
        box.scrollLeft = box.scrollLeft + width;
        console.log(width)
    }
  return (
     recomm &&
    <div>
    <h2>Recommendation</h2>
    <div className='Ritems'>
    {/* <button className="Rpre-btn" onClick={btnpressprev}><p>&lt;</p></button>
    <button className="Rnext-btn" onClick={btnpressnext}><p>&gt;</p></button> */}
        {
            Object.values(recomm).map((item)=>(
                <Link to={"/moviesdetails"} style={{textDecoration:'none',color:'inherit'}}>
                 <div className='Ritem'>   
                <div className='Ritem' onClick={()=>handlesetId(item.id)}>
                <img className='Rimg' src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}></img>
                <div>{item.vote_average}</div>
                <div style={{wordWrap:'wordBreak',overflow:"hidden"}}>
                    {
                        item.title? <a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.title}</a>:<a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.name}</a>
                    }
                </div>
                <div>{item.release_date?item.release_date:<h5>upcoming</h5>}</div>
                </div>
                </div>
                </Link>
            ))
        }
    </div>
    </div>
  )
}

export default Recommendation